/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import Config from "../Utils/Config";
const url: any = process.env.REACT_APP_WEBSOCKET_URL || 'wss://portal.sigurlavolan.ro';
const socket = io(url, {
  transports: ["websocket"],
  extraHeaders: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  },
  secure: true,
});
/**
 *
 */
export const WebSocketContext = createContext<any>({
  shouldUpdate: false,
  setShouldUpdate: (value: boolean) => { },
  socket: socket,
});

export const WebsocketProvider = (props: any) => {
  /**
   *
   * @param shouldUpdate
   */
  const setShouldUpdate = (shouldUpdate: boolean) => {
    setState({ ...state, shouldUpdate: shouldUpdate });
  };

  const initState = {
    shouldUpdate: false,
    setShouldUpdate: setShouldUpdate,
    socket: socket,
  };
  const [state, setState] = useState(initState);

  // socket.on("connect_error", (err: any) => {
  //   // the reason of the error, for example "xhr poll error"
  //   console.log(err?.message);

  //   // some additional description, for example the status code of the initial HTTP response
  //   console.log(err?.description);

  //   // some additional context, for example the XMLHttpRequest object
  //   console.log(err?.context);
  // });

  // socket.on("disconnect", (reason, details: any) => {
  //   // the reason of the disconnection, for example "transport error"
  //   console.log(reason);

  //   // the low-level reason of the disconnection, for example "xhr post error"
  //   console.log(details.message);

  //   // some additional description, for example the status code of the HTTP response
  //   console.log(details.description);

  //   // some additional context, for example the XMLHttpRequest object
  //   console.log(details.context);
  // });

  /**
   *
   */
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token && token !== "") {
      const clientId = localStorage.getItem("clientId");
      socket.emit("storageData", {
        clientId,
      });
      socket.on(`${Config.cache_prefix}storage`, (data: any) => {
        localStorage.setItem(
          `${Config.cache_prefix}storage`,
          JSON.stringify(data)
        );
        const event = new Event(`${Config.cache_prefix}storage`);
        window.dispatchEvent(event);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.shouldUpdate]);

  return (
    <WebSocketContext.Provider value={state}>
      {props.children}
    </WebSocketContext.Provider>
  );
};
